export const groupAccountsIntoRanges = (integers: number[] | undefined) => {
    if (!integers?.length) return []

    const sorted = [...new Set(integers)].sort((a, b) => a - b)
    const ranges = []
    let start = sorted[0]
    let end = sorted[0]

    for (let i = 1; i <= sorted.length; i++) {
        if (i < sorted.length && sorted[i] === end + 1) {
            end = sorted[i]
        } else {
            if (start === end) {
                ranges.push(start.toString())
            } else {
                ranges.push(`${start}-${end}`)
            }
            if (i < sorted.length) {
                start = sorted[i]
                end = sorted[i]
            }
        }
    }

    return ranges
}